import { messages as errorMessages } from './Errors';

export default {
  ...errorMessages,
};
